import Phaser from 'phaser';
import { HitResult } from '../config/gameConfig';

interface ResultSceneData {
  totalScore: number;
  pitchResults: Array<{
    result: HitResult;
    distance: number;
    score: number;
    timingResult?: string; // スイングタイミング結果
    angle?: number; // 角度
  }>;
  totalPitches?: number; // 総打席数
}

export class ResultScene extends Phaser.Scene {
  constructor() {
    super({ key: 'ResultScene' });
  }

  private totalScore: number = 0;
  private pitchResults: ResultSceneData['pitchResults'] = [];
  private totalPitches: number = 0;
  private resultSound: Phaser.Sound.BaseSound | null = null;

  init(data: ResultSceneData): void {
    this.totalScore = data.totalScore || 0;
    this.pitchResults = data.pitchResults || [];
    this.totalPitches = data.totalPitches || 0;
  }

  create(): void {
    const { width, height } = this.scale;

    // 背景画像を表示（720×1280pxで作成済みのためリサイズ不要）
    const bgImage = this.add.image(width / 2, height / 2, 'bg_result');
    bgImage.setDepth(-1); // 最背面に配置

    // BGMを停止（GameSceneから継続している場合）
    try {
      // すべてのBGMサウンドを停止（念のため）
      this.sound.stopAll();
      // 個別にも確認
      const bgm = this.sound.get('bgm');
      if (bgm && bgm.isPlaying) {
        bgm.stop();
      }
    } catch (e) {
      console.warn('BGM停止エラー:', e);
      // エラーが発生した場合でも、すべてのサウンドを停止
      try {
        this.sound.stopAll();
      } catch (e2) {
        // 無視
      }
    }

    // Result画面のBGMを再生
    this.resultSound = this.sound.add('result', { loop: true, volume: 0.5 });
    this.resultSound.play();

    // 最終スコア（改行して表示）
    const scoreText = this.add
      .text(width / 2, height * 0.35 + 15, `総スコア\n${this.totalScore}`, {
        fontSize: '80px',
        fontFamily: 'YuseiMagic',
        color: '#ffffff', // 白色
        fontStyle: 'bold',
        align: 'center', // 中央揃え
      })
      .setOrigin(0.5);

    // Total打席数を表示（少し上に配置）
    const totalPitchesText = this.add
      .text(width / 2, height * 0.45 + 15, `打席数: ${this.totalPitches}`, {
        fontSize: '50px',
        fontFamily: 'YuseiMagic',
        color: '#ffffff', // 白色
        fontStyle: 'bold',
      })
      .setOrigin(0.5);

    // タイトルへ戻るボタン（画像を使用）
    const backButton = this.add.image(width / 2, height * 0.55, 'back_to_title');
    backButton.setDepth(10);
    backButton.setInteractive({ useHandCursor: true });

    // ホバー効果
    backButton.on('pointerover', () => {
      backButton.setTexture('back_to_title_hover');
    });
    backButton.on('pointerout', () => {
      backButton.setTexture('back_to_title');
    });

    // クリック/タップでタイトルへ戻る
    backButton.on('pointerdown', () => {
      // Result画面のBGMを停止
      if (this.resultSound && this.resultSound.isPlaying) {
        this.resultSound.stop();
      }
      this.scene.start('TitleScene');
    });
  }
}
